module.exports = __webpack_public_path__ + "static/media/blue_teo_logo.162c1049.png";